import * as api from '../api';
import { Model } from '../common';
import { MembershipProduct } from './MembershipProduct';

@Model('Membership')
export class Membership extends api.ApiMembership {
    level : MembershipProduct;
    product : MembershipProduct;

    private numberAsMoney(cents) {
        return `$${(cents / 100).toFixed(2)}`;
    }

    get pricePerPeriod() : string {
        return `${this.numberAsMoney(this.price)} / ${this.period}`;
    }
}